import React from "react";
import './cycle.css';
import fotoa from '../images/cycle/kama_yunek/thumb_BWYK1593_1024.jpg'
import fotob from '../images/cycle/kama_yunek/thumb_CAMQ1880_1024.jpg'
import fotoc from '../images/cycle/kama_yunek/thumb_CAPQ0131_1024.jpg'
import fotod from '../images/cycle/kama_yunek/thumb_GEWO5942_1024.jpg'
import fotoe from '../images/cycle/kama_yunek/thumb_HZOQ1951_1024.jpg'
import fotof from '../images/cycle/kama_yunek/thumb_KPDQ2667_1024.jpg'
import fotog from '../images/cycle/kama_yunek/thumb_SEXP4403_1024.jpg'
import fotoh from '../images/cycle/kama_yunek/thumb_WFVQ9920_1024.jpg'
import fotoi from '../images/cycle/kama_yunek/thumb_WMNQ6810_1024.jpg'
import fotoj from '../images/cycle/kama_yunek/thumb_XPWU3286_1024.jpg'


const AngelFallsAbseil = () => {
  return(
    <div className="">

        <div className="">
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                    
                    <div className="carousel-item active">
                    <img className="d-block w-100" src={fotoa} alt=""/>
                    </div>
                    
                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotob} alt=""/>
                    </div>
                    
                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotoc} alt=""/>
                    </div>
                    
                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotod} alt=""/>
                    </div>
                    
                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotoe} alt=""/>
                    </div>

                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotof} alt=""/>
                    </div>

                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotog} alt=""/>
                    </div>

                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotoh} alt=""/>
                    </div>

                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotoi} alt=""/>
                    </div>

                    <div className="carousel-item">
                    <img className="d-block w-100" src={fotoj} alt=""/>
                    </div>
                    
                </div>
        
                <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        </div>
        
        <div className="card text-center">
            <div className="card-header bg-white">
                <h3>Cycle...</h3>
                <h5>Peerless remote bike tracks on breathtaking landscapes</h5>
            </div>
            
            <br/>
            <a href="/request_info" className="rounded-0 btn btn-lg btn-primary btn-block">Interested?</a>
            <br/>

        </div>

    </div>

        
  );
};

export default AngelFallsAbseil;


// WEBPACK FOOTER //
// ./src/components/cycle.jsx